import request from '@/CommonDP/utils/request';
// 标准图层维护
export default {
  // 专业列表
  standardLayerList(params) {
    return request.get(`/standardLayer/professionalList`, { params });
  },
  // 图层列表
  categoriesList(params) {
    return request.get(`/standardLayer/categoriesList`, { params });
  },
  // 删除
  standardLayer_delete(id) {
    return request.post(`/standardLayer/deletecategories?id=` + id);
  },
  // /专业列表
  standardLayerListprofessional(params) {
    return request.get(`/standardLayer/listprofessional`, { params });
  },
  standardLayerLineWeight(params) {
    return request.get(`/standardLayer/lineWeight`, { params });
  },
  // 线型
  standardLayerGetlinear(enterpriseId) {
    return request.get(
      `/standardLayer/getlinear?enterpriseId=${enterpriseId}`
    );
  },
  // 新增
  standardLayerAddcategories(params) {
    return request.post(`/standardLayer/addcategories`, params);
  },
  // 详情
  standardLayerDetail(id) {
    return request.get(`/standardLayer/singlist?id=` + id);
  },
  // 修改
  standardLayerUpdate(params) {
    return request.post(`/standardLayer/updatecategories`, params);
  },
  // 专业列表
  standardLayerListSpecialty(params) {
    return request.get(`/standardLayer/list-specialty`, { params });
  },
  // 图层列表
  getNewstandardLayerList(params) {
    return request.get(`/standardLayer/list-xinrui-layers`, { params });
  },

  // 删除
  deleteNewStandardLayer(params) {
    return request.post(`/standardLayer/delete-xinrui-layers`, params);
  },
  // 新增
  addXinRuiStandardLayer(params) {
    return request.post(`/standardLayer/add-xinrui-layer`, params);
  },
  // 修改
  updateXinRuiStandardLayer(params) {
    return request.post(`/standardLayer/update-xinrui-layer`, params);
  },
  // 上传
  uploadStandardLayerImport(data) {
    return request.post('/standardLayer/import', data, { timeout: 0 });
  },
  standardLayerExportFailList(params) {
    return request({
      responseType: 'blob',
      url: '/standardLayer/exportFailList',
      method: 'post',
      data: params
    });
  }
};
